import React, { useEffect, useRef } from "react";

export default function RewardsSection() {
  const ref = useRef(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    // Observe all reveal elements
    const revealElements = document.querySelectorAll(".reveal");
    revealElements.forEach((el) => io.observe(el));

    // Fallback: Make elements visible after a short delay on mobile if observer doesn't trigger
    const fallbackTimer = setTimeout(() => {
      revealElements.forEach((el) => {
        if (!el.classList.contains("is-visible")) {
          el.classList.add("is-visible");
        }
      });
    }, 500);

    return () => {
      io.disconnect();
      clearTimeout(fallbackTimer);
    };
  }, []);

  const cards = [
    {
      title: "Join the Community",
      desc: "Become a verified member of the Synergy Coin community and gain access to exclusive opportunities. Membership allows you to participate in incentive programs, use affiliate tools, and grow alongside a global network of partners.",
    },
    {
      title: "Earn Rewards Through Referrals",
      desc: "Unlock community-based rewards by qualifying for Synergy Coin’s referral program. Share your unique link and earn coin incentives for every successful referral.",
    },
      {
      title: "How to Become a Community Member",
      desc: "Meet the eligibility criteria by accumulating a minimum of 400,000 Synergy Coins (equivalent to $200 in presale purchases). Once qualified, you will receive your unique affiliate code and referral link to start earning.",
    },
    
  ];

  return (
    <section
      ref={ref}
      className="text-white mt-6 sm:mt-12 md:pb-32 overflow-visible"
    >
      <div className="mx-auto flex max-w-8xl flex-col gap-4 px-4 sm:px-6 lg:px-0">
        <div className="space-y-4 text-left">
          <h2 className="reveal translate-y-6 opacity-0 text-4xl font-extrabold tracking-tight text-[#EBD3FF] sm:text-5xl transition-all duration-700 delay-100">
            Program
          </h2>
          <p className="reveal max-w-3xl translate-y-6 opacity-0 text-base leading-7 text-[#C5D2DF] transition-all duration-700 delay-200">
Unlock community-based rewards by qualifying for Synergy Coin’s referral program. Earn incentives by sharing your unique link and growing your network.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, index) => (
            <article
              key={card.title}
              style={{ transitionDelay: `${250 + index * 120}ms` }}
              className="reveal relative translate-y-6 opacity-0 rounded-2xl bg-white/5 p-6 text-left shadow-[0_10px_40px_rgba(0,0,0,0.5)] backdrop-blur-md transition-[transform,opacity,box-shadow] duration-700 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(160,110,255,0.5)]"
            >
              <div className="pointer-events-none absolute inset-0 -z-10 rounded-2xl bg-[radial-gradient(120%_60%_at_50%_10%,rgba(255,255,255,0.10),transparent_55%)]" />
              <h3 className="text-2xl font-semibold">{card.title}</h3>
              <p className="mt-3 text-sm leading-6 text-[#C5D2DF]">{card.desc}</p>
            </article>
          ))}
        </div>

        <div className="pb-24 sm:pb-0"></div>

        {/* Background Video Section (Hidden on Mobile) */}
        <div className="hidden md:block relative overflow-hidden rounded-3xl h-[35vh] lg:h-[60vh]">
          <div className="flex justify-center items-center w-full pl-10">
            <video
              className="h-full max-w-[1300px] w-full object-cover rounded-3xl"
              src="/images/video-main.mp4"
              autoPlay
              loop
              muted
              playsInline
              ref={(video) => {
                if (video) video.playbackRate = 0.7;
              }}
            />
          </div>
          <div className="pointer-events-none absolute inset-0 bg-black/20 rounded-3xl" />
        </div>
      </div>
    </section>
  );
}

